<template>
        <!-- Beer card -->
        <b-card border-variant="secondary" tag="article" style="width: 300px; margin-left:10px" class="mb-2">
            <!-- Transition for signing in -->
            <transition name="fade">
            <div v-if="performingRequest" class="loading">
                <p>Signing In..</p>
            </div>
            </transition>

            <!-- Login modal -->
            <b-modal no-fade size="l" :id="'modal-login'+beer.id" title="Sign In To Order" ok-title="Sign In" @ok="login()" >
                Sign In to order 
                <b-input-group prepend="Email" class="mt-3">
                    <b-form-input v-model="email"></b-form-input>
                </b-input-group>
                <b-input-group prepend="Password" class="mt-3">
                    <b-form-input type="password"  v-model="password"></b-form-input>
                </b-input-group>
                <!-- Forgot password -->
                <div style="color:grey; margin-top:10px">
                    <a @click="resetPassword()">Forgot Password?</a>
                </div>
                <div style="margin-top:10px">
                    Don't have an account?
                    <br>
                    <b-button  style="margin-top:5px" variant="primary" >
                        <router-link style='text-decoration:none; color:#fff' to="/createaccount" >
                            Join Keg Seeker, it's Free
                        </router-link>
                    </b-button>
                </div>
            </b-modal>

            <!-- Modal to show quantity error -->
            <b-modal no-fade size="l" :id="'modal-quantityzero'+this.beer.id" ok-only title="Error" ok-title="OK" v-model="modalQtyError">
                Please enter quantity before adding to cart   
            </b-modal>

            <!------------------------------------------>
            <!-- Modal to select size and add to card -->
            <!------------------------------------------>
            <b-modal no-fade size="xl" :id="'modal-cart' + beer.id" :title="'Add ' + beer.beerName + ' To Cart'" ok-title="Add To Cart" @ok="sendToCart"
                v-model="addToCartModalVisible" @cancel="cancelAddToCart()" header-bg-variant='info'
                header-text-variant="light">


                <!-- If clicked from email to add to cart directly, show some details of this beer -->
                <b-container v-if="selected">
                    <b-row>
                        <!-- Image -->
                        <b-col>
                            <div v-if="getImageSource" style="height:75px; text-align: center; cursor:pointer">
                                <img :src="getImageSource" height="75" fluid alt="Logo image"
                                @click="viewBrewerProfile(beer.uid, beer)"
                                >
                            </div>
                            <div v-else style="height:75px; text-align: center">
                                <img src="https://res.cloudinary.com/lo4xxr5lr/image/upload/v1574513408/stock/beer.jpg" height="75" fluid alt="Logo image">
                            </div>
                        </b-col>
                        <!-- Name and Description -->
                        <b-col>
                            <div style="text-align: center; font-size:14px; ">
                                <!-- Company -->
                                <div style="font-size:20px; margin-bottom:5px; font-weight:bolder">
                                    {{beer.brewer}}
                                </div>
                                <!-- Name -->
                                <div style="font-size:16px; margin-bottom:5px; font-weight:bold">
                                    {{beer.beerName}}
                                </div>
                                <!-- Type, ABV -->
                                <!-- Check if ABV -->
                                <div v-if="beer.abv" style="font-size:12px">
                                    <strong>{{beer.type}}</strong> {{beer.subType}} {{beer.abv}}% ABV
                                </div>
                                <div v-else style="font-size:12px">
                                    <strong>{{beer.type}}</strong> {{beer.subType}}
                                </div>
                            </div>
                        </b-col>
                    </b-row>  
                    <hr>
                </b-container>
                
                <b-container>
                    <!-- Generic beer -->
                    <b-row v-if="!beer.multiSize">
                        <b-col>
                            Available: {{beer.quantity}}
                        </b-col>
                        <b-col>
                            <div style='color:red' v-if="exceedsGenericQty"> <small>Please enter a quantity between 1 and {{beer.quantity}}</small></div>
                            <b-form-input v-model="genericQty"  type="number"  min="0" :max="beer.quantity" placeholder="Order Qty"  ></b-form-input>
                        </b-col>
                    </b-row>
                    <!-- End of generic beer -->

                    <!-- Multi size beer -->
                    <!-- Enter quantity -->
                    <!-- Barrel 1 -->
                    <b-row v-if="beer.multiSize&&beer.barrel1Size&&beer.barrel1Quantity>0">
                        <div style='color:red' v-if="exceedsBarrel1Qty"> <small>Please enter a quantity less or equal to available</small></div>
                        <b-col cols='2'>
                            <img width="20px" src="../assets/barrel.png"/>
                        </b-col>
                        <b-col cols='6'>
                            {{beer.barrel1Size}}, <div><small>{{beer.barrel1Quantity}} available</small></div>
                        </b-col>
                        <!-- Barrel 1 large screen -->
                        <b-col cols='3' v-if="getWindowWidth>800">
                             <b-button-group  style="border-width:1px; border-color:#bfbfbf; border-style:solid; border-radius:5px">
                                <b-button  variant="transparent"><font-awesome-icon icon="minus"  @click="updateBarrel1Quantity(-1)"/></b-button>
                                <div style="width:50px; text-align:center; border-width:2px; border-color:#000; margin-top:5px"> {{barrel1Qty}}</div>
                                <b-button variant="transparent"><font-awesome-icon icon="plus"  @click="updateBarrel1Quantity(1)"/></b-button>
                            </b-button-group>
                        </b-col>
                    </b-row>

                    <!-- Barrel 1 small screen -->
                    <b-row v-if="getWindowWidth<=800&&beer.multiSize&&beer.barrel1Size&&beer.barrel1Quantity>0" style="margin-top:10px">
                        <b-col>
                             <b-button-group  style="border-width:1px; border-color:#bfbfbf; border-style:solid; border-radius:5px">
                                <b-button  variant="transparent"><font-awesome-icon icon="minus"  @click="updateBarrel1Quantity(-1)"/></b-button>
                                <div style="width:50px; text-align:center; border-width:2px; border-color:#000; margin-top:5px"> {{barrel1Qty}}</div>
                                <b-button variant="transparent"><font-awesome-icon icon="plus"  @click="updateBarrel1Quantity(1)"/></b-button>
                            </b-button-group>
                        </b-col>
                        
                    </b-row>
                    <hr>

                    <!-- Barrel 2 -->
                    <b-row v-if="beer.multiSize&&beer.barrel2Size&&beer.barrel2Quantity>0">
                        <b-col cols='2'>
                            <img width="20px" src="../assets/barrel.png"/>
                        </b-col>
                        <b-col cols='6'>
                            {{beer.barrel2Size}}, <small>{{beer.barrel2Quantity}} available</small>
                        </b-col>
                        <b-col cols='3' v-if="getWindowWidth>800">
                            <b-button-group  style="border-width:1px; border-color:#bfbfbf; border-style:solid; border-radius:5px">
                                <b-button  variant="transparent"><font-awesome-icon icon="minus"  @click="updateBarrel2Quantity(-1)"/></b-button>
                                <div style="width:50px; text-align:center; border-width:2px; border-color:#000; margin-top:5px"> {{barrel2Qty}}</div>
                                <b-button variant="transparent"><font-awesome-icon icon="plus"  @click="updateBarrel2Quantity(1)"/></b-button>
                            </b-button-group>
                        </b-col>
                    </b-row>
                    <!-- Barrel 2 small screen -->
                    <b-row v-if="getWindowWidth>800&&beer.multiSize&&beer.barrel2Size&&beer.barrel2Quantity>0" style="margin-top:10px">
                        <b-col v-if="getWindowWidth<=800">
                            <b-button-group  style="border-width:1px; border-color:#bfbfbf; border-style:solid; border-radius:5px">
                                <b-button  variant="transparent"><font-awesome-icon icon="minus"  @click="updateBarrel2Quantity(-1)"/></b-button>
                                <div style="width:50px; text-align:center; border-width:2px; border-color:#000; margin-top:5px"> {{barrel2Qty}}</div>
                                <b-button variant="transparent"><font-awesome-icon icon="plus"  @click="updateBarrel2Quantity(1)"/></b-button>
                            </b-button-group>
                        </b-col>
                    </b-row>
                    <hr  v-if="beer.multiSize&&beer.barrel2Size&&beer.barrel2Quantity>0">

                    <!-- Cans -->
                    <b-row v-if="beer.multiSize&&beer.cansPerCase&&beer.canQuantity>0">
                        <b-col cols='2'>
                            <img width="20px" src="../assets/can2.png"/>
                        </b-col>
                        <b-col cols='6'>
                            {{beer.cansPerCase}} cans/case, <small>{{beer.canQuantity}} available</small>
                        </b-col>
                        <!-- Can large screen -->
                        <b-col cols='3' v-if="getWindowWidth>800">
                            <b-button-group  style="border-width:1px; border-color:#bfbfbf; border-style:solid; border-radius:5px">
                                <b-button  variant="transparent"><font-awesome-icon icon="minus"  @click="updateCanQuantity(-1)"/></b-button>
                                <div style="width:50px; text-align:center; border-width:2px; border-color:#000; margin-top:5px"> {{canQty}}</div>
                                <b-button variant="transparent"><font-awesome-icon icon="plus"  @click="updateCanQuantity(1)"/></b-button>
                            </b-button-group>
                        </b-col>
                    </b-row>

                    <!-- Can small screen -->
                    <b-row style="margin-top:10px">
                        <b-col v-if="getWindowWidth<=800&&beer.multiSize&&beer.cansPerCase&&beer.canQuantity>0">
                            <b-button-group  style="border-width:1px; border-color:#bfbfbf; border-style:solid; border-radius:5px">
                                <b-button  variant="transparent"><font-awesome-icon icon="minus"  @click="updateCanQuantity(-1)"/></b-button>
                                <div style="width:50px; text-align:center; border-width:2px; border-color:#000; margin-top:5px"> {{canQty}}</div>
                                <b-button variant="transparent"><font-awesome-icon icon="plus"  @click="updateCanQuantity(1)"/></b-button>
                            </b-button-group>
                        </b-col>

                    </b-row>
                    <hr v-if="beer.multiSize&&beer.cansPerCase&&beer.canQuantity>0">

                    <!-- Bottles -->
                    <b-row v-if="beer.multiSize&&beer.bottlesPerCase&&beer.bottleQuantity>0">
                        <b-col cols='2'>
                            <img width="20px" src="../assets/bottle.png"/>
                        </b-col>
                        <b-col cols='6'>
                            {{beer.bottlesPerCase}} bottles/case, <small>{{beer.bottleQuantity}} available</small>
                        </b-col>
                        <!-- Buttons for large devices -->
                        <b-col v-if="getWindowWidth>800" cols='3'>
                            <b-button-group  style="border-width:1px; border-color:#bfbfbf; border-style:solid; border-radius:5px">
                                <b-button  variant="transparent"><font-awesome-icon icon="minus"  @click="updateBottleQuantity(-1)"/></b-button>
                                <div style="width:50px; text-align:center; border-width:2px; border-color:#000; margin-top:5px"> {{bottleQty}}</div>
                                <b-button variant="transparent"><font-awesome-icon icon="plus"  @click="updateBottleQuantity(1)"/></b-button>
                            </b-button-group>
                        </b-col>
                    </b-row>

                    <!-- Buttons for small devices -->
                    <b-row v-if="getWindowWidth<=800&&beer.multiSize&&beer.bottlesPerCase&&beer.bottleQuantity>0" style="margin-top:10px">
                        <b-col>
                            <b-button-group  style="border-width:1px; border-color:#bfbfbf; border-style:solid; border-radius:5px">
                                <b-button  variant="transparent"><font-awesome-icon icon="minus"  @click="updateBottleQuantity(-1)"/></b-button>
                                <div style="width:50px; text-align:center; border-width:2px; border-color:#000; margin-top:5px"> {{bottleQty}}</div>
                                <b-button variant="transparent"><font-awesome-icon icon="plus"  @click="updateBottleQuantity(1)"/></b-button>
                            </b-button-group>
                        </b-col>
                    </b-row>
                </b-container>

                <template v-slot:modal-footer="{ ok, cancel }">
                    <!-- Emulate built in modal footer ok and cancel button actions -->
                    <b-button size="sm" variant="success" @click="ok()"
                        :disabled="exceedsBarrel1Qty||exceedsBarrel2Qty||exceedsCanQty||exceedsBottleQty||exceedsGenericQty"
                    >
                        Add to Cart
                    </b-button>
                    <b-button size="sm" variant="outline-secondary" @click="cancel()">
                        Cancel
                    </b-button>
                </template>

            </b-modal>
            <!------------------------------------------>
            <!-- End of modal to select size and add to card -->
            <!------------------------------------------>

            <!------------------------------------------>
            <!-- Modal to add services -->
            <!------------------------------------------>
            <b-modal v-model="modalSelectServices" @ok="sendToCart" @cancel="sendToCart" title="Do you need any of these services?">
                <table class="table" >
                    <tbody>
                        <template v-for="theService in servicesList">
                            <tr :key="theService.service">
                                <!-- Button to select unselect -->
                                <td>
                                    <b-button v-if="!theService.selected" variant="outline-secondary" @click="selectService(theService)" style="height:40px; width:40px">
                                    </b-button>
                                    <b-button v-else variant="outline-secondary"  style="height:40px; width:40px" @click="unSelectService(theService)">
                                        <font-awesome-icon icon="check-square" />
                                    </b-button>
                                </td>
                                <!-- Name -->
                                <td>{{theService.service}}</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </b-modal>

            <!----------------------->
            <!-- Beer display card -->
            <!----------------------->
            <b-container fluid>
                <!-- Image -->
                <b-row>
                    <b-col>
                        <div v-if="getImageSource" style="height:75px; text-align: center; cursor:pointer">
                            <img :src="getImageSource" height="75" fluid alt="Logo image"
                            @click="viewBrewerProfile(beer.uid, beer)"
                            >
                        </div>
                        <div v-else style="height:75px; text-align: center">
                            <img src="https://res.cloudinary.com/lo4xxr5lr/image/upload/v1574513408/stock/beer.jpg" height="75" fluid alt="Logo image">
                        </div>
                    </b-col>
                </b-row>                 

                <b-row>
                    <b-col>
                        <div class='beerbreweryname' @click="viewBrewerProfile(beer.uid, beer)">
                            <h6> <a>{{beer.brewer}}</a> </h6>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div style="text-align: center; font-size:14px; ">
                            <!-- Name -->
                            <div style="font-size:16px; margin-bottom:5px; font-weight:bolder">
                                {{beer.beerName}}
                            </div>
                            <!-- Type, ABV -->
                            <!-- Check if ABV -->
                            <div v-if="beer.abv" style="font-size:12px">
                                <strong>{{beer.type}}</strong> {{beer.subType}} {{beer.abv}}% ABV
                            </div>
                            <div v-else style="font-size:12px">
                                <strong>{{beer.type}}</strong> {{beer.subType}}
                            </div>
                            <div>
                                <small>Delivered By: {{beer.deliveryMethod}}</small>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <hr>
                <!-- Containers -->
                <b-row>
                    <b-col>
                        <div style="text-align:center; font-size:14px;">
                            <b-container fluid>
                                <!-- Non multi size -->
                                <b-row v-if="!beer.multiSize">
                                    <b-col  v-if="beer.container=='Barrel'" cols='1'>
                                        <img width="20px" src="../assets/barrel.png"/> 
                                    </b-col>
                                    <b-col  v-if="beer.container=='Barrel'" cols="10">
                                        <small>{{beer.size}}</small>,  <span style="color:green"><small> ${{beer.cost}}</small> </span>
                                    </b-col>
                                    <b-col  v-if="beer.container=='cans'" cols='1'>
                                        <img width="20px" src="../assets/can2.png"/> 
                                    </b-col>
                                    <b-col  v-if="beer.container=='cans'" cols="10">
                                        <small>Case of {{beer.perCase}} {{beer.container}} {{beer.size}} {{beer.units}}</small>,  <span style="color:green"><small> ${{beer.cost}}</small> </span>
                                    </b-col>
                                    <b-col  v-if="beer.container=='bottles'" cols='1'>
                                        <img width="20px" src="../assets/bottle.png"/> 
                                    </b-col>
                                    <b-col  v-if="beer.container=='bottles'" cols="10">
                                        <small>Case of {{beer.perCase}} {{beer.container}} {{beer.size}} {{beer.units}}</small>,  <span style="color:green"><small> ${{beer.cost}}</small> </span>
                                    </b-col>
                                </b-row>
                                <!-- Multi size -->
                                <b-row v-if="beer.multiSize==1">
                                    <b-col>
                                        <div  style="text-align:left" v-if="beer.barrel1Size&&beer.barrel1Quantity>0">
                                            <img width="20px" src="../assets/barrel.png"/> <small>{{beer.barrel1Size}}, </small> 
                                            <span v-if="beer.ispostoffering==1&&beer.barrel1Cost<beer.origBarrel1Cost" style="color:red"><small> <s>${{beer.origBarrel1Cost}}</s></small> </span>
                                            <span style="color:green"><small> ${{beer.barrel1Cost}}</small> </span>
                                        </div>
                                        <div  style="text-align:left; margin-top:5px" v-if="beer.barrel2Size&&beer.barrel2Quantity>0">
                                            <img width="20px" src="../assets/barrel.png"/> <small>{{beer.barrel2Size}}, </small> 
                                            <span v-if="beer.ispostoffering==1&&beer.barrel2Cost<beer.origBarrel2Cost" style="color:red"><small> <s>${{beer.origBarrel2Cost}}</s></small> </span>
                                            <span style="color:green"><small> ${{beer.barrel2Cost}}</small> </span>
                                        </div>
                                        <div style="text-align:left; margin-top:5px" v-if="beer.cansPerCase&&beer.canQuantity>0">
                                            <img width="20px" src="../assets/can2.png"/> <small>{{beer.ozPerCan}} oz/can, {{beer.cansPerCase}}/case, </small> 
                                            <span v-if="beer.ispostoffering==1&&beer.canCost<beer.origCanCost" style="color:red"><small> <s>${{beer.origCanCost}}</s></small> </span>
                                            <span style="color:green"><small> ${{beer.canCost}}</small> </span>
                                        </div>
                                        <div  style="text-align:left; margin-top:5px" v-if="beer.bottlesPerCase&&beer.bottleQuantity>0">
                                            <img width="20px" src="../assets/bottle.png"/> <small>{{beer.ozPerBottle}} oz/bottle, {{beer.bottlesPerCase}}/case, </small> 
                                            <span v-if="beer.ispostoffering==1&&beer.bottleCost<beer.origBottleCost" style="color:red"><small> <s>${{beer.origBottleCost}}</s></small> </span>
                                            <span style="color:green"><small> ${{beer.bottleCost}}</small> </span>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-container>
                        </div>   
                    </b-col>       
                </b-row>
            </b-container>

            <!-- Tell me more collapsible -->
            <b-container fluid>
                <b-row>
                    <b-col>
                        <div style="text-align:center">
                        <div v-b-toggle="'collapse' + beer.id"  v-b-tooltip.hover title="Tell me more" @click="clickedTellMeMore(beer)">
                            <font-awesome-icon icon="angle-down" />
                        </div>
                        <b-collapse :id="'collapse' + beer.id"  class="mt-2"> 
                            <p class="card-text"><small>{{beer.description}}</small></p>
                        </b-collapse>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        
            <!-- Add to cart button -->
            <div v-if="userProfile">
            <b-container fluid v-if="userProfile.isbrewer==0">
                <b-row style="">
                    <div class="btn-group " style='margin-top:10px; margin-bottom:5px; '>
                        <b-button-group>
                            <b-button size="sm" class="btn btn-secondary btn-success" @click="showAddToCartModal"
                                :disabled="!beer.barrel1Quantity&&!beer.barrel2Quantity&&!beer.canQuantity&&!beer.bottleQuantity&&!beer.quantity">
                                Add to Cart<font-awesome-icon icon="shopping-cart" />
                            </b-button>
                            <b-button size="sm" @click="sendMessageModalVisible=true"
                                class='btn  btn-secondary action-buttons'><i><font-awesome-icon icon="comment" /></i>
                            </b-button>
                            <b-modal size="sm" v-model="sendMessageModalVisible" no-fade :id="'SendMsg' + beer.id" title="Send a Message"  hide-footer>
                                <div>
                                    <sendmessage  :receiverId="beer.uid" :receiverName="beer.brewer"  :arrayDefaultMessages="arrayDefaultMessages"/>
                                </div>
                            </b-modal>
                        
                            <b-button size="sm" v-if="shouldShowSearch" v-b-tooltip.hover :title="'See more from '+ beer.brewer " class="btn btn-info btn-primary action-buttons"  @click="viewBrewerProfile(beer.uid)" > 
                                <font-awesome-icon icon="list" />
                            </b-button>

                        </b-button-group>
                    </div> 
                </b-row>
            </b-container>
            </div>

        </b-card>

</template>

<script>
import { mapState } from 'vuex'
import Sendmessage from './Sendmessage'
const fb = require('../firebaseConfig.js')
import firebase from 'firebase/app';
    export default {
        components: {
            Sendmessage,
        },

        computed: {
            ...mapState(['userProfile', 'currentUser', 'uiVersion']),
            //Check order quantities are less than or equal to max quantity
            getImageSource(){
                //return {"uri": this.navigation.getParam("beer").logoFileThumbnailURL}
                if(this.beer.beerLogoURL) return this.beer.beerLogoURL
                else if (this.beer.logoFileThumbnailURL) return  this.beer.logoFileThumbnailURL
                else return require('../assets/beer.jpg')
            },

            exceedsBarrel1Qty(){
                if((this.beer.barrel1Quantity>0)&&(this.barrel1Qty>this.beer.barrel1Quantity||this.barrel1Qty<0)) return true
                else return false
            },
            exceedsBarrel2Qty(){
                if ((this.beer.barrel2Quantity>0)&&(this.barrel2Qty>this.beer.barrel2Quantity||this.barrel2Qty<0)) return true
                else return false
            },
            exceedsCanQty(){
                if((this.beer.canQuantity>0)&&(this.canQty>this.beer.canQuantity||this.canQty<0)) return true
                else return false
            },
            exceedsBottleQty(){
                if((this.beer.bottleQuantity>0)&&(this.bottleQty>this.beer.bottleQuantity||this.bottleQty<0)) return true
                else return false
            },
            exceedsGenericQty(){
                if ((this.beer.quantity>0)&&(this.genericQty>this.beer.quantity||this.genericQty<0)) return true
                else return false
            },
            checkIfIsFav(){

            },

            //Window size
            getWindowWidth(){
                return window.innerWidth;
            },
        },
        props: ['beer', 'shouldShowSearch', 'sentFromCarousel', 'showCartSidebar', 'selected'],
        data() {
            return {
                showSuccess: false,
                barrel1Qty:0,
                barrel2Qty:0,
                canQty:0,
                bottleQty:0,
                genericQty:0,
                arrayDefaultMessages:[
                    'Could you please send me some samples',
                ],
                cloudinary: {
                    beerimagespreset: 'beerimagespreset',
                    beerimagesthumbnail:'beerimagesthumbnail',
                    apiKey: '629997215451183',
                    cloudName: 'lo4xxr5lr',
                    uploadURL:'https://api.cloudinary.com/v1_1/lo4xxr5lr/image/upload'
                    }, 
                addToCartModalVisible:false,
                sendMessageModalVisible:false,
                email:'',
                password:'',
                errorMsg:'',
                performingRequest:false,
                modalQtyError:false,
                modalSelectServices:false,
                servicesList:[
                    {service:'Send tap handles', selected:false},
                    {service:'Pick up empty kegs', selected:false},

                ],
            }
        },

        methods: {

            showServicesModal(){
                this.modalSelectServices=true
            },
            showAddToCartModal(){
                if(this.currentUser){
                    //Add to colletion
                    var theData = {
                        pub:this.userProfile.company,
                        pubid:this.currentUser.uid,
                        brewer:this.beer.brewer,
                        brewerid:this.beer.uid,
                        createdOn: new Date(),
                        beerdocid: this.beer.docId,
                        beerid:this.beer.id,
                        beer:this.beer.beerName,
                    }
                fb.clickedAddToCartCollection.add(theData)
                }

                this.addToCartModalVisible=true
                //this.$bvModal.show("modal-cart" + this.beer.id)

            },

            sendToCart(){
                //Check if quantities have been entered
                if(this.beer.multiSize>0){
                    
                    if((this.barrel1Qty<=0||isNaN(this.barrel1Qty))&&(this.barrel2Qty<=0||isNaN(this.barrel2Qty))&&(this.canQty<=0||isNaN(this.canQty))&&(this.bottleQty<=0||isNaN(this.bottleQty)))
                    {
                        this.modalQtyError=true
                        //this.$bvModal.show("modal-quantityzero" + this.beer.id)
                        return
                    }
                    else this.addMultiSizeToCart()

                }
                else{
                    if(this.genericQty<=0||isNaN(this.genericQty)){
                        this.modalQtyError=true
                        this.$bvModal.show("modal-quantityzero" + this.beer.id)
                        return
                    }
                    else this.addGenericSizeToCart()

                }
            },
            cancelAddToCart(){
                this.genericQty = 0
                this.barrel1Qty = 0
                this.barrel2Qty = 0
                this.canQty = 0
                this.bottleQty = 0

            },
            addGenericSizeToCart(){
                var beerToAdd = copyObject(this.beer)
                function copyObject(obj){
                        var nobj = {};
                        for (let key in obj) {
                            if (typeof obj[key] === 'object'){
                                nobj[key] = copyObject(obj[key]);
                            } else {
                                nobj[key] = obj[key];
                            }
                        }
                        return nobj;
                    }

                //Add image source
                beerToAdd.beerLogoURL=this.getImageSource
                console.log("Logo = " + this.getImageSource)
                //console.log("Adding generic to cart max qty = " + beerToAdd.quantity)
                beerToAdd.totalCost = parseInt(this.genericQty) * beerToAdd.cost
                beerToAdd.orderQuantity = parseInt(this.genericQty)
                beerToAdd.available = beerToAdd.quantity
                var randomIdString1 = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
                beerToAdd.suborderid=randomIdString1
                //beerToAdd.quantity = this.beer.quantity
                this.$store.commit('addToCart', beerToAdd)
                if(beerToAdd.container == '"cans') beerToAdd.size = beerToAdd.perCase + ' Can Case'
                if(beerToAdd.container == '"bottles') beerToAdd.size = beerToAdd.perCase + ' Bottle Case'

                this.genericQty = ''
                this.barrel1Qty = ''
                this.barrel2Qty = ''
                this.canQty = ''
                this.bottleQty = ''

            },

            addMultiSizeToCart(){
                //Need to do this copy, otherwise the beer object remains reactive
                    function copyObject(obj){
                        var nobj = {};
                        for (let key in obj) {
                            if (typeof obj[key] === 'object'){
                                nobj[key] = copyObject(obj[key]);
                            } else {
                                nobj[key] = obj[key];
                            }
                        }
                        return nobj;
                    }

                var barre1Beer = copyObject(this.beer)
                var barre2Beer =  copyObject(this.beer)
                var canBeer =  copyObject(this.beer)
                var bottleBeer =  copyObject(this.beer)

                barre1Beer.beerLogoURL=this.getImageSource
                barre2Beer.beerLogoURL=this.getImageSource
                canBeer.beerLogoURL=this.getImageSource
                bottleBeer.beerLogoURL=this.getImageSource

                //Add a separate order for each container
                if(this.barrel1Qty>0&&!isNaN(this.barrel1Qty)){
                    console.log("Barrel1")
                    var randomIdString1 = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
                    barre1Beer.suborderid=randomIdString1
                    barre1Beer.container = 'barrel1'
                    barre1Beer.orderQuantity = parseInt(this.barrel1Qty)
                    barre1Beer.available = barre1Beer.barrel1Quantity
                    barre1Beer.size = barre1Beer.barrel1Size
                    barre1Beer.cost = barre1Beer.barrel1Cost
                    this.$store.dispatch('addBeerToCartMultisize', barre1Beer)
                }
                if(this.barrel2Qty>0&&!isNaN(this.barrel2Qty)){
                    console.log("Barrel2")
                    var randomIdString2 = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
                    barre2Beer.suborderid=randomIdString2
                    barre2Beer.container = 'barrel2'
                    barre2Beer.orderQuantity = parseInt(this.barrel2Qty)
                    barre2Beer.available = barre2Beer.barrel2Quantity
                    barre2Beer.size = barre2Beer.barrel2Size
                    barre2Beer.cost = barre2Beer.barrel2Cost
                    this.$store.dispatch('addBeerToCartMultisize', barre2Beer)
                }
                if(this.canQty>0&&!isNaN(this.canQty)){
                    console.log("Can")
                    var randomIdString3 = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
                    canBeer.suborderid=randomIdString3
                    canBeer.container = 'can'
                    canBeer.orderQuantity = parseInt(this.canQty)
                    canBeer.available = canBeer.canQuantity
                    canBeer.size = canBeer.cansPerCase + ' Can Case'
                    canBeer.cost = canBeer.canCost
                    this.$store.dispatch('addBeerToCartMultisize', canBeer)
                }
                if(this.bottleQty>0&&!isNaN(this.bottleQty)){
                    console.log("Bottle")
                    var randomIdString4 = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
                    bottleBeer.suborderid=randomIdString4
                    bottleBeer.container = 'bottle'
                    bottleBeer.orderQuantity = parseInt(this.bottleQty)
                    bottleBeer.available = bottleBeer.bottleQuantity
                    bottleBeer.size = bottleBeer.bottlesPerCase + ' Bottle Case'
                    bottleBeer.cost = bottleBeer.bottleCost
                    this.$store.dispatch('addBeerToCartMultisize', bottleBeer)
                }
                this.barrel1Qty = 0
                this.barrel2Qty = 0
                this.canQty = 0
                this.bottleQty = 0

                //Forcibly hide add to cart modal
               this.$bvModal.hide("modal-cart" + this.beer.id)

               this.$nextTick(() => {
                        this.showCartSidebar()
                    })
               
            },

            //Update quantity
            updateBarrel1Quantity(updateNumber){
                //Make sure everything is int
                this.barrel1Qty = parseInt(this.barrel1Qty)
                this.barrel1Qty = this.barrel1Qty + parseInt(updateNumber)
                //Check if negative number
                if (this.barrel1Qty <0) this.barrel1Qty = 0
                //Check if quantity exceeded
                if(parseInt(this.beer.barrel1Quantity)<this.barrel1Qty) this.barrel1Qty = this.beer.barrel1Quantity
            },
            updateBarrel2Quantity(updateNumber){
                this.barrel2Qty = parseInt(this.barrel2Qty)
                this.barrel2Qty = this.barrel2Qty + parseInt(updateNumber)
                //Check if negative number
                if (this.barrel2Qty <0) this.barrel2Qty = 0
                //Check if quantity exceeded
                if(parseInt(this.beer.barrel2Quantity)<this.barrel2Qty) this.barrel2Qty = this.beer.barrel2Quantity
            },
            updateCanQuantity(updateNumber){
                this.canQty = parseInt(this.canQty) 
                this.canQty = this.canQty + parseInt(updateNumber)
                //Check if negative number
                if (parseInt(this.canQty) <0) this.canQty = 0
                //Check if quantity exceeded
                if(this.beer.canQuantity<this.canQty) this.canQty = this.beer.canQuantity
            },
            updateBottleQuantity(updateNumber){
                this.bottleQty=parseInt(this.bottleQty)
                this.bottleQty = this.bottleQty + parseInt(updateNumber)
                //Check if negative number
                if (parseInt(this.bottleQty) <0) this.bottleQty = 0
                //Check if quantity exceeded
                if(this.beer.bottleQuantity<this.bottleQty) this.bottleQty = this.beer.bottleQuantity
            },

            //Mark as favorite
            markAsFavorite(brewerId, brewer){
                fb.usersCollection.doc(this.currentUser.uid).update({
                    favorites: firebase.firestore.FieldValue.arrayUnion(brewerId)
                    });

                    this.$bvToast.toast(brewer + 'Added to favorites', {
                        title: 'Keg Seeker',
                        autoHideDelay: 2000,
                        appendToast: false,
                        solid:true,
                        variant:'success',
                        })

            },
            unFavorite(brewerId, brewer){
                this.$store.dispatch('unFavorite', brewerId)
                this.$bvToast.toast(brewer + 'Removed from favorites', {
                        title: 'Keg Seeker',
                        autoHideDelay: 2000,
                        appendToast: false,
                        solid:true,
                        variant:'warning',
                        })

            },

            viewBrewerProfile(brewerId, beer){
                if(this.currentUser){
                    //Add to colletion
                    var theData = {
                        pub:this.userProfile.company,
                        pubid:this.currentUser.uid,
                        brewerid:brewerId,
                        createdOn: new Date(),
                    }
                fb.clickedBrewerCollection.add(theData)
                }
                var query = {
                    brewerId: brewerId
                }
                if(beer.distbrewerid) query.distbrewerid = beer.distbrewerid
                this.$router.push({ path: 'breweryprofile', query: query})
            },

            //Clicked tell me more
            clickedTellMeMore(beer){
                //Only track if logged in
                if(this.currentUser){
                    //Add to colletion
                    var theData = {
                        pub:this.userProfile.company,
                        pubid:this.currentUser.uid,
                        brewer:beer.brewer,
                        brewerid:beer.uid,
                        createdOn: new Date(),
                        beerdocid: beer.docId,
                        beerid:beer.id,
                        beer:beer.beerName,
                        state:this.userProfile.state,
                        county:this.userProfile.county,
                    }
                fb.clickedTellMeMoreCollection.add(theData)
                }
                
            },
            //Login user
            login(){
                this.performingRequest = true
                console.log("Signing in ")
                this.errorMsg = ""
                fb.auth.signInWithEmailAndPassword(this.email, this.password).then(user => {
                    this.$store.commit('setCurrentUser', user.user)
                    this.performingRequest = false
                    this.addToCartModalVisible=true
                        
                }).catch(err => {
                    this.isLoggedIn=false
                    console.log(err)
                    this.performingRequest = false
                    this.errorMsg = err.message
                })
            },

            //Reset password
            resetPassword(){
                this.performingRequest = false
                this.$router.push({path:'/forgotpassword'})
            },

            //Select service
            selectService(service){

            },

            unSelectService(service){

            },

        },
        mounted(){
            //Check if a beer was selected
            if(this.selected){
                //Check if user is logged in
                if(this.currentUser) this.addToCartModalVisible=true
                else this.$bvModal.show("modal-login"+this.beer.id)
                
            } 

        }
        
    }
</script>
<style>
.beerbreweryname{
    color:  #f67409;
    text-align: center; 
    cursor:pointer;
    margin-top:5px;
}

#toolbar .wrapper {
    text-align: center;
}

.beername{

}
.beerstyle{

}
</style>